<template>
  <div :class="className" class="schedule-section__row" >
    <div class="schedule-section__time">
        <span>{{ time }}</span>
    </div>
    <div class="schedule-section__event">
      <ScheduleEntry v-for="(entry, index) in entries" :key="index" :entry="entry" />
    </div>
  </div>
</template>


<script>
import ScheduleEntry from './ScheduleEntry.vue'

export default {
  name: 'ScheduleTime',
  components: { ScheduleEntry },
  props: ['starts_at', 'ends_at', 'entries'],
  computed: {
    className() {
      const currentTime = this.$store.state.currentTime
      if (new Date(this.ends_at) <= currentTime) {
        return 'done'
      } else if (new Date(this.starts_at) <= currentTime && new Date(this.ends_at) > currentTime) {
        return 'current'
      } else {
        return ''
      }
    },
    time() {
      return `${this.starts_at.slice(11,16)} - ${this.ends_at.slice(11,16)}`
    }

  }
}
</script>

<style lang="scss" scoped>
</style>
